import { createAsyncThunk } from "@reduxjs/toolkit";
import { AppDispatch, RootState } from "../store";
import { handleRequest } from "../utils/handleRequest";
import { notificationApi } from "../../api/notificationApi";
import { PaginationParameters } from "../../api/Pagination";
import { PaginatedData } from "../../hooks/PaginationHooks";
import { GenericInAppNotification, GenericInAppNotificationFilterParameters, GenericInAppNotificationResponse } from "../../types/notificationType";


export const fetchInAppNotificationsThunk = createAsyncThunk<
    PaginatedData<GenericInAppNotificationResponse>,
    { paginationParams: PaginationParameters; filters: GenericInAppNotificationFilterParameters },
    { dispatch: AppDispatch; state: RootState }
>(
    "notifications/fetchInAppNotifications",
    async (
        { paginationParams, filters },
        { dispatch }
    ) => {
        const result = await handleRequest(
            dispatch,
            "indirect",
            () => notificationApi.getGenericInAppNotifications(paginationParams, filters)
        );
        if (result.success()) return result.result!;
        throw new Error(result.errorMessage ?? "Failed to fetch notifications");
    }
);

export const createNewNotificationThunk = createAsyncThunk<
number,
    GenericInAppNotification,
{ dispatch: AppDispatch; state: RootState }
>(
    "notifications/createNewNotificationThunk",
        async (notification, { dispatch }) => {
            const result = await handleRequest(
                dispatch,
                "direct",
                () => notificationApi.createGenericInAppNotification(notification)
            );
            if (result.success()) return result.result!;
            throw new Error(result.errorMessage ?? "Failed to create notification");
        }
);

export const updateNotificationThunk = createAsyncThunk<
    {},
    GenericInAppNotification,
    { dispatch: AppDispatch; state: RootState }
>(
    "notifications/updateNotificationThunk",
    async (
        notification,
        { dispatch }
    ) => {
        const result = await handleRequest(
            dispatch,
            "direct",
            () => notificationApi.updateGenericInAppNotification(notification.id!, notification)
        );
        if (result.success()) return result.result!;
        throw new Error(result.errorMessage ?? "Failed to update notificaiton");
    }
);

export const deleteNotificationThunk = createAsyncThunk<
    {},
    GenericInAppNotification,
    { dispatch: AppDispatch; state: RootState }
>(
    "notifications/deleteNotificationThunk",
    async (
        notification,
        { dispatch }
    ) => {
        const result = await handleRequest(
            dispatch,
            "direct",
            () => notificationApi.deleteGenericInAppNotification(notification.id!)
        );
        if (result.success()) return result.result!;
        throw new Error(result.errorMessage ?? "Failed to delete notificaiton");
    }
);
